/**
 * 关于我们相关路由
 */
export default [
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about/index.vue")
  }
];
